<div class="admin-editor-container">
    <!-- Spinner while source is being loaded -->
    <div *ngIf="loading && !loadError" class="pd-loader">
        <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
    </div>

    <!-- Error loading content -->
    <div *ngIf="!loading && loadError" class="pd-permission-error">
        <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
        There was an error loading the source. Click below try again.
        <button hc-button size="lg" (click)="loadSource()">Reload Source</button>
    </div>

    <div class="pd-admin-editor-page" [hidden]="loadError || loading">
        <ol class="breadcrumb pd-admin-editor-breadcrumbs">
            <li class="breadcrumb-item">
                <a routerLink="/admin/sources">Source</a>
                <i class="fa fa-chevron-right breadcrumb-arrow"></i>
            </li>
            <li class="breadcrumb-item">
                <span>{{ sourceID ? sourceForm.controls['nameControl'].value + ' (#' + itemID + ')' : 'New Source' }} </span>
                <i class="fa fa-chevron-right breadcrumb-arrow"></i>
            </li>
        </ol>
        <h2>
            <hc-icon fontSet="fa" [fontIcon]="sourceID ? 'fa-pencil' : 'fa-plus'"></hc-icon>
            {{ sourceID ? 'Edit' : 'Add ' }} Source
        </h2>

        <div>
            <div class="pd-admin-editor-container">
                <!-- EDITOR TAB CONTENT -->
                <div [formGroup]="sourceForm" [hidden]="selectedTab !== 0">
                    <div class="pd-admin-editor-actions-bar">
                        <div class="pd-admin-editor-action-buttons pd-admin-editor-sources-save">
                            <button hc-button buttonStyle="primary" class="save-button"
                                [disabled]="!sourceInputsDirty || !sourceForm.valid"
                                (click)="checkID(true)">
                                Save
                            </button>
                            <em *ngIf="sourceInputsDirty">unsaved changes</em>
                        </div>
                    </div>
                    <div class="pd-admin-editor-form pd-admin-editor-sources-form">
                        <div class="edit-fields" [class.edit-form]="itemID !== undefined">
                            <div hcTileHeader>Identifying Information</div>
                            <hc-form-field>
                                <hc-label>Name:</hc-label>
                                <input hcInput formControlName="nameControl" placeholder="Enter name" [required]="true" />
                                <hc-error>A name is required</hc-error>
                            </hc-form-field>
                            <hc-form-field>
                                <hc-label>Item Number:</hc-label>
                                <input hcInput formControlName="IDControl" placeholder="Enter item number" [required]="true" (blur)="checkID(false)" />
                                <hc-error>An unique item number is required</hc-error>
                            </hc-form-field>
                            <hc-form-field>
                                <hc-label>Status:</hc-label>
                                <hc-select formControlName="statusControl" placeholder="Select status" [placeholderValue]="null"  [required]="true">
                                    <option *ngFor="let status of statuses" [ngValue]="status.statusID">{{
                                        status.name }}</option>
                                </hc-select>
                                <hc-error>A status is required</hc-error>
                            </hc-form-field>
                            <hc-form-field>
                                <hc-label>Type:</hc-label>
                                <hc-select formControlName="typeControl" placeholder="Select type"
                                    [placeholderValue]="null" [required]="true">
                                    <option *ngFor="let type of types" [ngValue]="type.typeID">{{ type.name }}
                                    </option>
                                </hc-select>
                                <hc-error>A type is required</hc-error>
                            </hc-form-field>
                            <hc-label>Revision Date:</hc-label>
                            <div id="revision-date"> {{ (this.revisionDate ? this.revisionDate : '') | date: 'fullDate' }}  {{ !this.revisionDate ? '--' : ''}}</div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</div>